var exports = {
  "B": "circleProgressBar__zTE1Aw",
  "G": "exceeded__sMZvzJ",
};

module.exports = exports;
